import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  position: absolute;
  inset-block-start: 0;

  inline-size: 100vw;
  block-size: 100%;

  overflow: hidden;
`;

export const IconsContainer = styled.div`
  position: absolute;
  inset-block-start: 0;

  display: none;

  inline-size: 1440px;
  block-size: 100%;
  margin-inline-start: calc(50vw - 720px);
  ${theme.breakpoints.up("desktop")} {
    display: flex;
  }
`;

export const TopRightContainer = styled.div`
  position: absolute;
  inset-block-start: 280px;
  inset-inline-end: 180px;
`;

export const BottomLeftContainer = styled.div`
  position: absolute;
  inset-block-end: 180px;
  inset-inline-start: 157px;
`;

export const BottomRightContainer = styled.div`
  position: absolute;
  inset-block-end: 270px;
  inset-inline-end: 96px;
`;
